import { useAuthStore } from '~/stores/auth'
import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { jwtDecode } from 'jwt-decode'
import dayjs from 'dayjs'

export default defineNuxtRouteMiddleware((to) => {
  const nuxtApp = useNuxtApp()

  const authStore = useAuthStore()

  if (!authStore.token) {
    return nuxtApp.runWithContext(() =>
      navigateTo({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    )
  }

  const decodedToken = jwtDecode(authStore.token.accessToken)

  if (decodedToken.exp) {
    // Check if jwt token expired more than a day ago
    const expiresAt = dayjs.unix(decodedToken.exp).tz('Europe/Amsterdam').add(1, 'day')

    if (expiresAt.isBefore(dayjsUTC())) {
      return nuxtApp.runWithContext(() =>
        navigateTo({
          name: 'login',
          query: { redirect: to.fullPath }
        })
      )
    }
  }
})
